<mat-toolbar #pickingCompletePanel [style.display]="shipment?.isComplete ? 'flex' : 'none'" role="toolbar"
    style="font-size: 14px; background-color:transparent; padding: 0 5px;">
    <span style="line-height:1.1em;">Picking Complete
        <span *ngIf="shipment?.CutAndHold"><br /><em>Cut & Hold</em></span>
    </span>
    <span style="flex: 1 1 auto;"></span>
    <button *ngIf="!(shipment?.CutAndHold)" mat-raised-button color="primary" (click)="updateShipmentToAcumatica()">
        <mat-icon>shop</mat-icon> Update Shipment
    </button>
    <button *ngIf="shipment?.CutAndHold" mat-raised-button color="primary" (click)="updateShipmentToAcumatica()">
        <mat-icon>shelves</mat-icon> Hold Shipment
    </button>
</mat-toolbar>

<mat-toolbar id="memoPickingToolbar" [style.display]="quickMemoEntryEnabled ? 'inline-block' : 'none'" role="toolbar"
    style="background-color:transparent; margin-top:5px;">
    <div class="input-row" style="font-size:12px;">
        <fieldset>
            <mat-form-field appearance="fill">
                <mat-label>Inventory ID</mat-label>
                <input #memoInventoryID matInput [(ngModel)]="memoPickInventoryID" scanInput="ITM"
                    (scanned)="onMemoPickFormSubmit()" [disabled]="!inventoryDoneLoading" />
            </mat-form-field>
            <div class="last-pick-feedback" [innerHTML]="memoPickQty"></div>
        </fieldset>
    </div>
</mat-toolbar>

<mat-accordion *ngIf="shipment; else shipmentLoading">
    <!-- Shipment Detail row expansion panel -->
    <mat-expansion-panel *ngFor="let detail of shipment.Details; let idx = index"
        [style.display]="showCompletedLines || !detail.isComplete ? 'block' : 'none'"
        class="shipment-detail-expansion-panel" hideToggle
        (opened)="onShipmentDetailPanelOpened(detail, picksTable, idx)"
        (closed)="onShipmentDetailPanelClosed(idx, detail)">
        <mat-expansion-panel-header class="right-aligned-panel-description">
            <!-- expansion panel header, Left side -->
            <mat-panel-title>
                <item-thumbnail [item]="stockItem[detail.InventoryID]"></item-thumbnail>
                <mat-icon *ngIf="detail.isComplete">checkmark</mat-icon>
                <div>{{detail.InventoryID}}<br />
                    <div class="item-description">{{stockItem[detail.InventoryID]?.Description || detail.Description}}</div>
                </div>
            </mat-panel-title>
            <!-- expansion panel header, right side -->
            <mat-panel-description>
                <span
                    *ngIf="!detail.isComplete && detail.SuggestedPickingSource">{{detail.SuggestedPickingSourceLocation}}</span>

                <!-- expansion panel menu button-->
                <button matSuffix mat-button [matMenuTriggerFor]="itemmenu" (click)="$event.stopPropagation()">
                    <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #itemmenu="matMenu">
                    <a mat-menu-item (click)="editNote(detail)">
                        <mat-icon>note_add</mat-icon>
                        <span>Note</span>
                    </a>
                    <a mat-menu-item [routerLink]="['/item', detail.InventoryID]" target="_blank">
                        <mat-icon>not_listed_location</mat-icon>
                        <span>Item Inquiry</span>
                    </a>
                    <button mat-menu-item *ngIf="isDevMode && !detail.isComplete && detail.PreAllocation"
                        (click)="ignorePreAllocation(detail)">
                        <mat-icon>lock_open</mat-icon>
                        <span>Ignore Pre-Allocation</span>
                    </button>
                    <button mat-menu-item *ngIf="isDevMode && detail.SuggestedPickingSource"
                        (click)="copyStockQRToClipboard(detail.InventoryID, detail.SuggestedPickingSource.LotSerialNbr!)">
                        <mat-icon>content_paste</mat-icon>
                        <span>Copy To Clipboard</span>
                    </button>
                </mat-menu>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <!-- Pick & Order quantity information -->
        <table class="piece-info-table" *ngIf="itemPickingReady(detail.InventoryID); else itemDataStillLoading">
            <tr>
                <td>
                    <label>Picked: </label>
                    {{detail.fulfillmentQty}}
                    <span *ngIf="detail.allowanceQty">({{detail.allowanceQty | signed}})</span> of {{detail.OrderedQty}}
                    {{detail.UOM}}
                </td>
                <td *ngIf="detail.PickedQty < detail.OrderedQty">
                    <label>Open: </label>
                    {{detail.OrderedQty - detail.fulfillmentQty}} {{detail.UOM}}
                </td>
                <td *ngIf="detail.PickedQty > detail.OrderedQty">
                    <label>Allowance: </label>
                    {{detail.PickedQty - detail.OrderedQty}} {{detail.UOM}}
                </td>
            </tr>
            <tr *ngIf="detail.isComplete && detail.isLotSerItem">
                <td colspan="3"><button mat-raised-button color="accent"
                        (click)="enableAddingPicksToCompletedLine(detail)">Adtl. Piece</button></td>
            </tr>
        </table>

        <!-- Lot/Serial & Quantity entry form -->
        <form *ngIf="itemPickingReady(detail.InventoryID) && !detail.isComplete" class="pick-entry-form"
            [formGroup]="pickFormGroups[detail.LineNbr!]" (ngSubmit)="onPickEntrySubmit()">
            <div>
                <mat-form-field *ngIf="detail.isLotSerItem" style="width:160px" appearance="fill">
                    <mat-label>Lot / Serial #</mat-label>
                    <input #lotNbrInputField scanInput="LOT" matInput formControlName="lotSerNbr"
                        (scanned)="onLotSerialNbrEntered($event, detail)"
                        [placeholder]="detail.SuggestedPickingSourceSerialLotNbr" />
                    <button mat-icon-button matSuffix type="button" *ngIf="lotNbrInputField.value"
                        (click)="current.LotSerNbr.reset()">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-form-field><br />

                <span></span>

                <mat-form-field style="width:70px" appearance="fill">
                    <mat-label>Qty</mat-label>
                    <input inputmode='quantity' matInput formControlName="qty" (keydown.enter)="onPickEntrySubmit()" />
                </mat-form-field>

                <span *ngIf="!detail.isLotSerItem">
                    <span>&nbsp;</span>
                    <button type="submit" mat-raised-button color="primary" style="line-height: 50px;">OK</button>
                    <span>&nbsp;</span>
                </span>
            </div>
            <div *ngIf="detail.isLotSerItem">
                <button type="button" mat-raised-button color="accent" [disabled]="!this.current.source"
                    *ngIf="stockItem[detail.InventoryID]?.isRolledGood" (click)="onPickEntryEditDetails()">
                    <mat-icon>edit</mat-icon>
                </button>

                <span></span>

                <button type="button" mat-raised-button color="accent" *ngIf="detail.QuickAction"
                    (click)="detail.QuickAction.action()">{{detail.QuickAction.label}}</button>

                <span></span>

                <button type="submit" mat-raised-button color="primary" [disabled]="!this.current.source">OK</button>
            </div>
        </form>

        <!-- Panel Tabs -->
        <mat-tab-group #tabGroup class="detail-panel-tabs" (selectedIndexChange)="current.focusFirstInput()">
            <mat-tab label="* Note *" *ngIf="detail.note">
                <div style="white-space:pre-line;">{{detail.note}}</div>
                <hr *ngIf="salesOrder[detail.SOKey]?.note && detail.note" />
                <div style="white-space:pre-line;" *ngIf="salesOrder[detail.SOKey]?.note">
                    {{salesOrder[detail.SOKey]?.note}}</div>
            </mat-tab>

            <mat-tab label="Pre-Allocated" *ngIf="detail.PreAllocation">
                <div><label>Location:</label> {{detail.PreAllocation.LocationID}}</div>
                <div><label>Lot #:</label> {{detail.PreAllocation.LotSerialNbr}}</div>
            </mat-tab>

            <mat-tab label="Inventory" *ngIf="!detail.PreAllocation">
                <table mat-table class="inventory-table in-tab-table" [dataSource]="inventory[detail.InventoryID]">
                    <ng-container matColumnDef="LocationID">
                        <th mat-header-cell *matHeaderCellDef>Location</th>
                        <td mat-cell *matCellDef="let inventory"
                            [class.defaultBinLocation]="inventory.LocationID == stockItem[detail.InventoryID]?.DefaultIssueFrom">
                            {{inventory.LocationID}}</td>
                    </ng-container>

                    <ng-container matColumnDef="LotSerialNbr">
                        <th mat-header-cell *matHeaderCellDef class="inventory-lotsernbr"
                            [hidden]="!detail.isLotSerItem">Lot #</th>
                        <td mat-cell *matCellDef="let inventory" class="inventory-lotsernbr"
                            [hidden]="!detail.isLotSerItem" (click)="toggleLotDisplay(inventory)">{{displayHashCodes ?
                            (inventory.LotSerialHash || inventory.LotSerialNbr) : inventory.LotSerialNbr}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CutCount">
                        <th mat-header-cell *matHeaderCellDef class="inventory-cutcount"></th>
                        <td mat-cell *matCellDef="let inventory" class="inventory-cutcount"
                            [hidden]="!detail.isLotSerItem">
                            {{inventory.CutCount === null ? '?' : inventory.CutCount}} |&nbsp;
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="QtyAvailable">
                        <th mat-header-cell *matHeaderCellDef>Avail</th>
                        <td mat-cell *matCellDef="let inventory">
                            <span [class.inventorySourceInUse]="inventory.AdjustmentQty || inventory.UsageCount">
                                {{inventory.AdjQtyAvailable}}<span
                                    *ngIf="inventory.stockItem?.isRolledGood && !inventory.PFASFree">📛</span></span>
                            <span *ngIf="inventory.AltSOPreAllocated" style="font-size:0.8em;"><br />(of
                                {{inventory.AdjQtyOnHand}})</span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef class="allocation-menu-column">&nbsp;</th>
                        <td mat-cell *matCellDef="let inventory"
                            style="white-space:nowrap; text-align:right; padding-right:0;">

                            <button mat-icon-button [matMenuTriggerFor]="inventoryItemMenu"
                                *ngIf="current.item?.isRolledGood">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <mat-menu #inventoryItemMenu>
                                <button *ngIf="isDevMode" mat-menu-item (click)="consoleLog(inventory)">
                                    <mat-icon>adb</mat-icon>Log Inventory Summary
                                </button>

                                <div mat-menu-item (click)="$event.stopPropagation()" *ngIf="inventory.UsageCount != 0">
                                    <mat-icon>shopping_cart</mat-icon>Used for {{inventory.UsageCount}}
                                    Piece{{(inventory.UsageCount==1)?'':'s'}}
                                </div>

                                <div mat-menu-item (click)="transferInventoryPiece(inventory)">
                                    <mat-icon>trending_up</mat-icon>
                                    <span *ngIf="inventory.LocationID != inventory.OriginalLocationID">
                                        Transfer: {{inventory.OriginalLocationID}} to
                                        {{inventory.LocationID}}</span>
                                    <span *ngIf="inventory.LocationID == inventory.OriginalLocationID">
                                        Transfer Bin Location
                                    </span>
                                </div>

                                <div mat-menu-item (click)="editInventoryAdjustment(inventory)">
                                    <mat-icon>expand</mat-icon>
                                    <span *ngIf="inventory.AdjustmentQty">Adjustment: {{inventory.AdjustmentQty |
                                        signed}}
                                        {{inventory.BaseUOM}}</span>
                                    <span *ngIf="!inventory.AdjustmentQty">Adjust On Hand</span>
                                </div>

                                <button mat-menu-item (click)="printStockRollTag(inventory)">
                                    <mat-icon>sell</mat-icon>Print Stock Tag
                                </button>

                                <button mat-menu-item
                                    (click)="copyStockQRToClipboard(detail.InventoryID, inventory.LotSerialNbr)">
                                    <mat-icon>qr_code_2</mat-icon>Copy Stock QR
                                </button>
                            </mat-menu>

                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="inventoryDisplayColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: inventoryDisplayColumns;"></tr>
                </table>
            </mat-tab>

            <mat-tab label="Picks">
                <table #picksTable mat-table class="in-tab-table" [dataSource]="detail.Allocations">
                    <ng-container matColumnDef="LocationID">
                        <th mat-header-cell *matHeaderCellDef>Location</th>
                        <td mat-cell *matCellDef="let inventory">{{inventory.LocationID}}</td>
                    </ng-container>

                    <ng-container matColumnDef="LotSerialNbr">
                        <th mat-header-cell *matHeaderCellDef class="inventory-lotsernbr"
                            [hidden]="!detail.isLotSerItem">Lot / Serial #</th>
                        <td mat-cell *matCellDef="let allocation" class="inventory-lotsernbr"
                            [hidden]="!detail.isLotSerItem">
                            {{allocation.LotSerialNbr}}</td>
                    </ng-container>

                    <ng-container matColumnDef="Qty">
                        <th mat-header-cell *matHeaderCellDef>Qty</th>
                        <td mat-cell *matCellDef="let allocation">{{allocation.Qty}}</td>
                    </ng-container>

                    <ng-container matColumnDef="Flag">
                        <th mat-header-cell *matHeaderCellDef></th>
                        <td mat-cell *matCellDef="let allocation" style="padding-left:5px;"></td>
                    </ng-container>

                    <ng-container matColumnDef="menu">
                        <th mat-header-cell *matHeaderCellDef class="allocation-menu-column">&nbsp;</th>
                        <td mat-cell *matCellDef="let allocation" style="white-space:nowrap; padding-right:0;">

                            <button matSuffix mat-icon-button (click)="allocation.delete()"
                                *ngIf="!current.item?.isRolledGood">
                                <mat-icon>delete</mat-icon>
                            </button>

                            <button mat-icon-button [matMenuTriggerFor]="allocationPickMenu"
                                *ngIf="current.item?.isRolledGood">
                                <mat-icon>more_vert</mat-icon>
                            </button>

                            <mat-menu #allocationPickMenu>
                                <button mat-menu-item (click)="onPickMenuOpenPickDetailEditor(allocation)"
                                    *ngIf="current.item?.isRolledGood && !allocation.readonly">
                                    <mat-icon>edit</mat-icon>Edit Pick Details
                                </button>
                                <button mat-menu-item *ngIf="shipment.CutAndHold"
                                    (click)="printCutAndHoldTag(allocation)">
                                    <mat-icon>shelves</mat-icon>Print Cut&Hold Tag
                                </button>
                                <button mat-menu-item (click)="printStockRollTag(allocation)">
                                    <mat-icon>sell</mat-icon>Print Stock Tag
                                </button>
                                <button mat-menu-item (click)="printCustomerRollLabel(allocation)">
                                    <mat-icon>video_label</mat-icon>Print Customer Roll Label
                                </button>
                            </mat-menu>

                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="allocationsDisplayColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: allocationsDisplayColumns;"></tr>
                </table>
            </mat-tab>
        </mat-tab-group>
    </mat-expansion-panel>
</mat-accordion>

<ng-template #shipmentLoading>
    <mat-spinner diameter="25" style="display:inline-block; margin: 0 0.5em;">
    </mat-spinner>Getting Shipment Details...
</ng-template>

<ng-template #selectLocationForLotSerNbrDialogTemplate let-data>
    <h3>Lot # exists in multiple Locations</h3>
    <div *ngFor="let piece of data.inventory" style="text-align:center;">
        <button *ngIf="piece.LocationID == current.detail!.SuggestedPickingSourceLocation" mat-raised-button
            style="margin:0.2em;" color="primary" [mat-dialog-close]="piece">
            {{piece.QtyAvailable}} {{current.detail!.UOM}} in {{piece.LocationID}}
        </button>
        <button
            *ngIf="piece.LocationID != current.detail!.SuggestedPickingSourceLocation && piece.QtyAvailable >= this.current.detail!.OpenQty"
            mat-raised-button style="margin:0.2em;" color="accent" [mat-dialog-close]="piece">
            {{piece.QtyAvailable}} {{current.detail!.UOM}} in {{piece.LocationID}}
        </button>
        <button
            *ngIf="piece.LocationID != current.detail!.SuggestedPickingSourceLocation && piece.QtyAvailable < this.current.detail!.OpenQty"
            mat-raised-button style="margin:0.2em;" color="warn" [mat-dialog-close]="piece">
            {{piece.QtyAvailable}} {{current.detail!.UOM}} in {{piece.LocationID}}
        </button>
    </div>
</ng-template>

<ng-template #selectLocationForMemoDialogTemplate let-data>
    <h3>Not available from Primary Location</h3>
    <mat-checkbox [(ngModel)]="doMemoTransferToPrimaryLocation">Transfer to primary</mat-checkbox>
    <div *ngFor="let piece of data.inventory" style="text-align:center;">
        <button *ngIf="piece.LocationID == current.detail!.SuggestedPickingSourceLocation" mat-raised-button
            style="margin:0.2em;" color="primary" [mat-dialog-close]="piece">
            {{piece.QtyAvailable}} {{current.detail!.UOM}} in {{piece.LocationID}}
        </button>
        <button
            *ngIf="piece.LocationID != current.detail!.SuggestedPickingSourceLocation && piece.QtyAvailable >= this.current.detail!.OpenQty"
            mat-raised-button style="margin:0.2em;" color="accent" [mat-dialog-close]="piece">
            {{piece.QtyAvailable}} {{current.detail!.UOM}} in {{piece.LocationID}}
        </button>
        <button
            *ngIf="piece.LocationID != current.detail!.SuggestedPickingSourceLocation && piece.QtyAvailable < this.current.detail!.OpenQty"
            mat-raised-button style="margin:0.2em;" color="warn" [mat-dialog-close]="piece">
            {{piece.QtyAvailable}} {{current.detail!.UOM}} in {{piece.LocationID}}
        </button>
    </div>
</ng-template>

<ng-template #specifyMemoTransferQtyDialogTemplate let-data>
    <h3 style="margin-bottom:0;">Location Transfer</h3>
    <table>
        <tr>
            <td style="text-align:right;">From:</td>
            <td>{{data.source.LocationID}}</td>
        </tr>
        <tr>
            <td style="text-align:right;">To:</td>
            <td>{{current.item!.DefaultIssueFrom}}</td>
        </tr>
    </table>
    <div style="font-size:0.6em;">(including order quantity of {{current.detail!.OrderedQty!}})</div>
    <mat-form-field class="qty-field" floatLabel="never" appearance="fill">
        <mat-label>Quantity</mat-label>
        <input matInput inputmode='quantity' [(ngModel)]="memoPickTransferQty" [autofocus] />
    </mat-form-field>

    <div style="display:flex; justify-content: space-between;">
        <button mat-raised-button color="accent"
            [mat-dialog-close]="data.source.QtyAvailable">{{data.source.QtyAvailable}}
            {{current.detail!.item!.SalesUOM}}</button>
        <button mat-raised-button color="primary" [mat-dialog-close]="memoPickTransferQty"
            [disabled]="!memoPickTransferQty">{{memoPickTransferQty}}
            {{current.detail!.item!.SalesUOM}}</button>
    </div>
</ng-template>

<ng-template #adjustInventoryDialogTemplate let-data>
    <inventory-adjustment-editor #adjustmentInlineEditor
        [OnHandLabel]="data.inventory.isLotSerItem ? 'Roll Balance' : 'On Hand'" [inventory]="data.inventory"
        [focusInput]="true"></inventory-adjustment-editor>

    <mat-dialog-actions style="justify-content: space-between;">
        <button mat-raised-button color="accent" [mat-dialog-close]="false">Cancel</button>

        <span></span>

        <button matSuffix mat-raised-button color="primary" [mat-dialog-close]="true"
            [disabled]="!data.inventory.AdjustmentAcceptable">OK</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #transferInventoryPieceDialogTemplate let-data>
    <form>
        <inventory-location-editor #inventoryTransferEditor [warehouseLocations]="warehouseLocations"
            [inventory]="data.inventory"></inventory-location-editor>
    </form>

    <mat-dialog-actions style="display: flex; justify-content: space-between;">
        <span></span>
        <button matSuffix mat-raised-button [mat-dialog-close]>Cancel</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #CutAndHoldLocationDialogTemplate let-data>
    <form>
        <mat-form-field appearance="fill" *ngIf="customer?.CustomLabelReportID">
            <mat-label>Customer-Specific Tag Printer</mat-label>
            <input name="CutHoldCustomerTagPrinterSelect" [(ngModel)]="CutAndHoldCustomerTagPrinterID" scanInput="PTR"
                type="text" matInput [matAutocomplete]="printerSelectAutocomplete">
            <mat-autocomplete #printerSelectAutocomplete="matAutocomplete">
                <mat-option *ngFor="let printer of settings.WarehousePrinters" [value]="printer.id">
                    {{printer.id}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field><br />

        <mat-form-field appearance="fill">
            <mat-label>Hold Location</mat-label>
            <input [scanInput] matInput scanInput="BIN" [formControl]="CutAndHoldLocation"
                (scanned)="onCutAndHoldLocationEntered($event)" />
        </mat-form-field>
    </form>

    <mat-dialog-actions style="display: flex; justify-content: space-between;">
        <span></span>
        <button matSuffix mat-raised-button [mat-dialog-close]>Cancel</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #shipmentCompletionStatus let-data>
    <div style="overflow-y: visible; max-height: 400px;">
        <h2>Complete Shipment</h2>
        <table>
            <tr *ngIf="data.status.InventoryAdjustments != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.InventoryAdjustments == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.InventoryAdjustments == CompleteShipmentStepStatus.Complete">done
                    </mat-icon>
                    <mat-icon *ngIf="data.status.InventoryAdjustments == CompleteShipmentStepStatus.Error">
                        error
                    </mat-icon>
                </td>
                <td>Updating Inventory</td>
            </tr>
            <tr *ngIf="data.status.ModifySOLines != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.ModifySOLines == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.ModifySOLines == CompleteShipmentStepStatus.Complete">done
                    </mat-icon>
                    <mat-icon *ngIf="data.status.ModifySOLines == CompleteShipmentStepStatus.Error"
                        class="feedback-error">
                        error
                    </mat-icon>
                </td>
                <td>Modifying SO Lines</td>
            </tr>
            <tr *ngIf="data.status.AddAllowancesToSO != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.AddAllowancesToSO == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.AddAllowancesToSO == CompleteShipmentStepStatus.Complete">done
                    </mat-icon>
                    <mat-icon *ngIf="data.status.AddAllowancesToSO == CompleteShipmentStepStatus.Error"
                        class="feedback-error">
                        error
                    </mat-icon>
                </td>
                <td>Adding Allowances to SO</td>
            </tr>
            <tr *ngIf="data.status.GetModifiedSOs != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.GetModifiedSOs == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.GetModifiedSOs == CompleteShipmentStepStatus.Complete">done
                    </mat-icon>
                    <mat-icon *ngIf="data.status.GetModifiedSOs == CompleteShipmentStepStatus.Error"
                        class="feedback-error">
                        error
                    </mat-icon>
                </td>
                <td>Retrieving Modified SO</td>
            </tr>
            <tr *ngIf="data.status.InventoryTransfers != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.InventoryTransfers == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.InventoryTransfers == CompleteShipmentStepStatus.Complete">done
                    </mat-icon>
                    <mat-icon *ngIf="data.status.InventoryTransfers == CompleteShipmentStepStatus.Error"
                        class="feedback-error">error
                    </mat-icon>
                </td>
                <td>Location Transfers</td>
            </tr>
            <tr *ngIf="data.status.UpdateShipment != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.UpdateShipment == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.UpdateShipment == CompleteShipmentStepStatus.Complete">done</mat-icon>
                    <mat-icon *ngIf="data.status.UpdateShipment == CompleteShipmentStepStatus.Error"
                        class="feedback-error">
                        error
                    </mat-icon>
                </td>
                <td>Updating Shipment</td>
            </tr>
            <tr *ngIf="data.status.CustomerSpecialRollTags != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.CustomerSpecialRollTags == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon
                        *ngIf="data.status.CustomerSpecialRollTags == CompleteShipmentStepStatus.Complete">done</mat-icon>
                    <mat-icon *ngIf="data.status.CustomerSpecialRollTags == CompleteShipmentStepStatus.Error">
                        error
                    </mat-icon>
                </td>
                <td>Printing Customer Labels</td>
            </tr>
            <tr *ngIf="data.status.PrintPacklist != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.PrintPacklist == CompleteShipmentStepStatus.InProcess"
                        diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.PrintPacklist == CompleteShipmentStepStatus.Complete">done</mat-icon>
                    <mat-icon *ngIf="data.status.PrintPacklist == CompleteShipmentStepStatus.Error"
                        class="feedback-error">
                        error
                    </mat-icon>
                </td>
                <td>Printing Pack List</td>
            </tr>
            <tr *ngIf="data.status.UploadImages != CompleteShipmentStepStatus.Omitted">
                <td>
                    <mat-spinner *ngIf="data.status.UploadImages == CompleteShipmentStepStatus.InProcess" diameter="30">
                    </mat-spinner>
                    <mat-icon *ngIf="data.status.UploadImages == CompleteShipmentStepStatus.Complete">done
                    </mat-icon>
                    <mat-icon *ngIf="data.status.UploadImages == CompleteShipmentStepStatus.Error"
                        class="feedback-error">
                        error
                    </mat-icon>
                </td>
                <td>Uploading Images</td>
            </tr>

            <tr *ngIf="data.status.Details">
                <td colspan="2">
                    <hr />{{data.status.Details}}
                </td>
            </tr>
            <tbody *ngIf="data.status.error">
                <tr>
                    <td colspan="2">
                        <hr />
                        <h3 class="feedback-error" [innerHTML]="data.status.error"></h3>
                    </td>
                </tr>
                <tr>
                    <td></td>
                    <td><button mat-raised-button color="accent" (click)="CloseProgressFeedback()">Dismiss</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>

<ng-template #itemDataStillLoading>
    <mat-spinner diameter="30" style="display:inline-block;"></mat-spinner> Getting Item & Inventory...
</ng-template>